import { Heading } from "@/components/ui/Heading";
import { SignupToFrontlineProps } from "./SignupToFrontlineProps";
import { Checkbox } from "@/components/ui/Checkbox";
import classes from "./SignupToFrontline.module.scss";
import { useDonationFormStore } from "@/stores";
import { useTranslation } from "@/hooks/useTranslation";

export function SignupToFrontline(props: SignupToFrontlineProps) {
  const { className, config } = props;
  const { signUpFrontline, setSignUpFrontline } = useDonationFormStore();

  const t = useTranslation("sign_up_to_frontline");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSignUpFrontline(event.target.checked);
  };

  return (
    <div className={className}>
      <div className={classes.header}>
        <Heading as="h3" size="lg" gutterBottom>
          {t(config["sign-up-to-frontline-title"].i18n)}
        </Heading>
        <div className={classes.formatter}>
          {t(config["sign-up-to-frontline-description"].i18n)}
        </div>
      </div>

      <div>
        <Checkbox checked={signUpFrontline} onChange={handleChange}>
          {t(config["sign-up-to-frontline-option-label"].i18n)}
        </Checkbox>
      </div>
    </div>
  );
}
